import React from "react";

import { IntlProvider } from "@eroad/i18n/IntlProvider";
import type { Locale } from "@eroad/types";
import { ConfigProvider as AntdConfigProvider } from "@eroad/ui-library/ConfigProvider";
import { enGB, enUS, frCA } from "@eroad/ui-library/locale/antd";

import { messages } from "./messages";

type LanguageProviderProps = React.PropsWithChildren<{
  locale: Locale;
  timeZone: string;
}>;

const LanguageProvider = ({ children, locale, timeZone }: LanguageProviderProps) => {
  return (
    <IntlProvider locale={locale} key={locale} messages={messages[locale]} onError={undefined} timeZone={timeZone}>
      <AntdConfigProvider locale={getAntLocaleFromLocale(locale)}>{children}</AntdConfigProvider>
    </IntlProvider>
  );
};

function getAntLocaleFromLocale(locale: Locale) {
  switch (locale) {
    case "en-NZ":
    case "en-AU":
      return enGB;
    case "fr-CA":
      return frCA;
    default:
      return enUS;
  }
}

export { getAntLocaleFromLocale, LanguageProvider };
